module.exports = "https://cdn.littlereply.com/tt/resource/settingNav.fd147b1162f3853c1b93abfb276fecf8.png";